import { CheckboxState } from '~/components/ui/nucleus/Checkbox';
import type { AggregateSelectState } from '~/helpers/notificationPrefsSelectAll';
import { PrefCheckbox } from './PrefCheckbox';

const toCheckboxState = (state: AggregateSelectState): CheckboxState => {
  if (state === 'all') return CheckboxState.CHECKED;
  if (state === 'partial') return CheckboxState.INDETERMINATE;
  return CheckboxState.UNCHECKED;
};

type Props = {
  state: AggregateSelectState;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  'aria-label'?: string;
};

/** Section-level Select All: below heading, checkbox + label, text-sm like row labels. */
export const SectionSelectAll = ({
  state,
  disabled,
  onChange,
  'aria-label': ariaLabel = 'Select All',
}: Props) => {
  return (
    <div className='flex w-fit items-center gap-2'>
      <PrefCheckbox
        state={toCheckboxState(state)}
        disabled={disabled}
        aria-label={ariaLabel}
        className='cursor-pointer'
        onChange={onChange}
      />
      <span className='text-sm text-primary'>Select All</span>
    </div>
  );
};

export { toCheckboxState };
